module.exports = __webpack_public_path__ + "static/media/pause.835591b6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icons/pause.svg
 ** module id = 379
 ** module chunks = 0
 **/